import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip"
import { Info } from "lucide-react"
import type { ReactNode } from "react"

interface GenericTooltipProps {
  content: string
  children: ReactNode
  side?: "top" | "right" | "bottom" | "left"
  showInfoIcon?: boolean
  className?: string
}

export function GenericTooltip({
  content,
  children,
  side = "top",
  showInfoIcon = false,
  className = "",
}: GenericTooltipProps) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div className={`inline-flex items-center gap-1 cursor-help ${className}`}>
            {children}
            {showInfoIcon && <Info className="h-3 w-3 text-gray-400 hover:text-gray-600 transition-colors" />}
          </div>
        </TooltipTrigger>
        <TooltipContent side={side}>
          <p>{content}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
